import { useLayoutEffect, useRef } from 'react'
import type { ReactNode } from 'react'
import { springEasing, SHEET_DURATION } from '@student/features/episodes/ui/spring'

/* ═══════════ EpisodeSheet ═══════════
   The Episode opens the way every sheet in the app opens: a dimmed veil
   over the screen you were on, and the panel springing up from the
   bottom edge. Same numbers as `ClanSheetModal` and the admin sheets —
   damping 28, stiffness 300, mass 0.8 — reproduced without Framer.

   The screen underneath stays mounted. That is the whole reason a sheet
   feels like a sheet: you can still see where you came from.

   VISIBLE NO ES ALCANZABLE [QA-009 · 2026-09-28]. Quedarse montada detrás la
   dejaba también en el orden de tabulación, y el foco se escapaba al catálogo.
   Quien marca el fondo como `inert` es `App.tsx`, que es quien sabe qué es el
   fondo; aquí se declara lo que esto ES —un diálogo modal— para que el lector
   de pantalla cuente la misma historia que el teclado. */

const VEIL_MS = 200

export function EpisodeSheet({ children }: { children: ReactNode }) {
  const veil = useRef<HTMLDivElement>(null)
  const panel = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduce) return

    const runs: Animation[] = []
    if (veil.current?.animate) {
      runs.push(
        veil.current.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: VEIL_MS,
          easing: 'ease-in-out',
          fill: 'both',
        }),
      )
    }
    if (panel.current?.animate) {
      runs.push(
        panel.current.animate([{ transform: 'translateY(100%)' }, { transform: 'none' }], {
          duration: SHEET_DURATION,
          easing: springEasing(),
          fill: 'both',
        }),
      )
    }
    return () => runs.forEach((r) => r.cancel())
  }, [])

  return (
    <>
      <div className="epveil" ref={veil} aria-hidden="true" />
      <div className="epsheet" ref={panel} role="dialog" aria-modal="true" aria-label="Episode">
        {children}
      </div>
    </>
  )
}
